import React from 'react'
import { Button, Modal } from '@driftt/tide-core-legacy'

const InnerDisableSalesSequenceModal = ({ onCloseClick, onDisableClick, playbook }) => {
  return (
    <Modal
      type="error"
      title={`All enrolled contacts will be unenrolled from ${playbook.name}`}
      size="small"
      open={true}
      className="playbook-list-disable-warning"
      onClose={onCloseClick}
    >
      <div className="playbook-list-disable-warning--body">
        All enrolled contacts in this playbook will be unenrolled if this playbook is disabled. Are you sure you want to disable it?
      </div>
      <footer className="playbook-list-disable-warning-footer">
        <Button type="secondary" onClick={onDisableClick}>Disable playbook</Button>
        <Button type="tertiary" onClick={onCloseClick}>Cancel</Button>
      </footer>
    </Modal>
  )
}

export default InnerDisableSalesSequenceModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/DisableSalesSequenceConfirmModal/InnerDisableSalesSequenceModal.js